import { faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "gatsby";
import React from "react";

const CompanyInfo = () => (
  <div className="column">
    <h3 className="is-size-6 border-b-l white-btm mb-space">Contact</h3>
    <div className="droid is-size-7">
      <p>
        No.7, Lorong Teknologi 3/4a, Nouvelle Industrial Park 2,
        <br />
        Taman Sains Selangor 1, Kota Damansara,
        <br />
        47810 Petaling Jaya, Selangor,Malaysia.
      </p>

      <br />

      <p>T +(603) 6143 6333</p>
      <p>F +(603) 6143 7333</p>

      <br />

      <a href="mailto:info@caffebene.com.my">info@caffebene.com.my</a>

      <br />
      <br />

      <p>Copyright &copy; by Caffebene. All right reserved.</p>
    </div>
  </div>
);

const Career = () => (
  <div className="column">
    <h3 className="is-size-6 border-b-l mb-space white-btm">Careers</h3>
    <Link className="footer-link is-size-7" to="/careers">
      Join the Crew!
    </Link>
  </div>
);

const MailingList = () => (
  <div className="column mailing-list is-5 ">
    <div className="has-text-centered mg-btm-2">
      <h2 className="footer-cta-text">Mailing List</h2>
    </div>

    <div className="field">
      <div className="control">
        <input
          className="custom-input droid"
          type="text"
          placeholder="Email Address"
        ></input>
      </div>
    </div>

    <div className="field">
      <button className="full-btn droid is-uppercase">Subscribe</button>
    </div>

    <div>
      <a href="https://www.facebook.com/caffebene.asia/" target="_blank">
        <span className="icon">
          <FontAwesomeIcon icon={faFacebookF} size="lg" color="whitesmoke" />
        </span>
      </a>
      <a href="https://www.instagram.com/caffebenemy/?hl=en" target="_blank">
        <span className="icon">
          <FontAwesomeIcon icon={faInstagram} size="lg" color="whitesmoke" />
        </span>
      </a>
    </div>
  </div>
);

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  scrollToTop(e) {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefo
  }

  render() {
    // let { data, leftText, rightText } = this.props;
    return (
      <div style={{ position: "relative" }}>
        <div className="btnToTop">
          <a
            href="#top"
            onTouchStart={this.scrollToTop}
            onClick={this.scrollToTop}
          >
            TOP
          </a>
        </div>
        <footer className="footer has-text-light">
          <div className="pd-lr-3">
            <div className="columns">
              <div className="column is-7">
                <div className="columns">
                  <CompanyInfo />
                  <Career />
                </div>
              </div>
              <MailingList />
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default Footer;
